import { DEFAULT_LOCALE, useLocaleData } from 'app/shared/hooks/intl-provider/intl-provider.hooks';

import React from 'react';
import { IntlProvider as ReactIntlProvider } from 'react-intl';
import { useOpenParams } from 'app/shared/hooks/use-open-params/use-open-params.hook';

interface IntlProviderProps {
  children: React.ReactNode;
}

export const IntlProvider: React.FC<IntlProviderProps> = ({ children }: IntlProviderProps): JSX.Element => {
  const { locale: configLocale } = useOpenParams();
  const { locale, messages } = useLocaleData(configLocale.toLowerCase());

  return (
    <ReactIntlProvider messages={messages} locale={locale} defaultLocale={DEFAULT_LOCALE}>
      {children}
    </ReactIntlProvider>
  );
};
